export { default as categoriesEpic } from './epic';
export type { FetchCategoriesAction } from './actions';
export { FETCH_CATEGORIES, fetchCategoriesAction } from './actions';
